import TabbedPage from './TabbedPage'

export default TabbedPage
